// src/data/landingMedia.js
// Photography used on the public marketing page. The files live in
// `public/landing/` and are served statically — no API call at render time,
// so the page has no dependency on a provider's rate limit.
//
// Both providers' API terms require attribution when their media is shown
// (Pexels: a prominent link back; Pixabay: show users where the media is
// from). That obligation is met by the credit line in the Landing footer,
// which is built from CREDITS below — keep the two in sync if images change.

const BASE = `${process.env.PUBLIC_URL || ""}/landing`;

export const img = (name) => `${BASE}/${name}.jpg`;

// name -> { provider, creator, page }
export const CREDITS = {
  "hero-main": { provider: "Pexels", creator: "Mikhail Nilov", page: "https://www.pexels.com/photo/8108427/" },
  "hero-a": { provider: "Pexels", creator: "Hameen Reynolds", page: "https://www.pexels.com" },
  "hero-b": { provider: "Pixabay", creator: "Sunriseforever", page: "https://pixabay.com" },
  "hero-c": { provider: "Pexels", creator: "Olya Prutskova", page: "https://www.pexels.com" },
  "feat-character": { provider: "Pexels", creator: "Bilal Yousufzai", page: "https://www.pexels.com" },
  "feat-image": { provider: "Pixabay", creator: "merlinlightpainting", page: "https://pixabay.com" },
  "feat-video": { provider: "Pexels", creator: "Shuvo Haque", page: "https://www.pexels.com" },
  "feat-drift": { provider: "Pexels", creator: "Youssef Hodroj", page: "https://www.pexels.com" },
  "drift-2": { provider: "Pexels", creator: "Vincuk Konan", page: "https://www.pexels.com" },
  "drift-3": { provider: "Pexels", creator: "Stacey Koenitz", page: "https://www.pexels.com" },
  "x-cta": { provider: "Pexels", creator: "Marek Piwnicki", page: "https://www.pexels.com" },
  "m-1": { provider: "Pexels", creator: "Pachon in Motion", page: "https://www.pexels.com" },
  "m-2": { provider: "Pexels", creator: "Khánh LP", page: "https://www.pexels.com" },
  "m-3": { provider: "Pixabay", creator: "Janson_G", page: "https://pixabay.com" },
  "m-4": { provider: "Pexels", creator: "6th Era Photography", page: "https://www.pexels.com" },
  "m-5": { provider: "Pixabay", creator: "Pexels", page: "https://pixabay.com" },
  "m-6": { provider: "Pexels", creator: "FILMASPER", page: "https://www.pexels.com" },
  "m-7": { provider: "Pixabay", creator: "mindofmush", page: "https://pixabay.com" },
  "m-8": { provider: "Pexels", creator: "Kenneth Surillo", page: "https://www.pexels.com" },
};

// Distinct providers in use, for the footer credit line.
export const PROVIDERS = [
  { name: "Pexels", url: "https://www.pexels.com" },
  { name: "Pixabay", url: "https://pixabay.com" },
];
